import React from "react";
import LanguageSwitcher from "../LanguageSwitcher";

const PlatformFooter: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left text-gray-600 text-xs">
            <p className="font-medium">
              © {new Date().getFullYear()} ushoplify{" "}
              <span className="text-gray-400">•</span> Multi-Store E-commerce
              Platform
            </p>
            <p className="text-gray-500 text-xs mt-2">Powered by ushoplify</p>
          </div>
          <div className="flex items-center justify-center gap-4">
            {/*       {location && (
       <div className="text-gray-600 text-xs">
        <span className="font-medium">{location.country}</span>
        {location.countryCode && (
         <span className="text-gray-400 ml-1">({location.countryCode})</span>
        )}
       </div>
      )} */}
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PlatformFooter;
